import React from 'react';
import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { Typography, Button, Box, FormControlLabel, FormGroup } from '@mui/material';
import BpCheckbox from '../../UI/BpCheckbox/BpCheckbox';
import TermsAndConditionsPDF from '../../../components/Layout/TermsAndConditionsPage/TermsAndConditions.pdf';
import { supabase } from '../../../api';
import { PROFILE_TABLE } from '../../../constants/supabase_constants';

const StepFourteenJoin = (props) => {
  //eslint-disable-next-line
  const [completed, setCompleted] = useState(true);
  const [termsAndConditionsAccepted, setTermsAndConditionsAccepted] = useState(false)
  let navigate = useNavigate();

  let { id } = useParams();

  const updateProfile = async () => {
    try {
      const updates = {
        id: id,
        onboardingCompleted: true,
        updated_at: new Date(),
        termsandconditionsAccepted: true,
      };

      let { error } = await supabase.from(PROFILE_TABLE).upsert(updates, {
        returning: 'minimal', // Don't return the value after inserting
      });

      if (error) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <React.Fragment>
      <Typography variant='h3' sx={{ mt: '3rem', mb: 1, fontWeight: 'bold' }}>
        That's it!
      </Typography>
      <Typography variant='body1' sx={{ mt: '1rem' }}>
        The 100 Club is filled with nothing but action-takers. And our job is to reward your actions, be it through
        networking opportunities or membership perks.
      </Typography>
      <Typography variant='body1' sx={{ mt: '1rem', mb: '0.5rem' }}>
        So, are you ready to join our community?
      </Typography>
      <a
        href='https://t.me/+ttRAwM6_kvc1OGFl'
        target='_blank'
        rel='noreferrer'
        onClick={(e) => {
          updateProfile();
          navigate(`/dashboard`);
        }}>
        <Button disabled={!termsAndConditionsAccepted} color='primary' variant='contained' fullWidth sx={{ mt: '1rem', textDecoration: 'none' }}>
          JOIN TELEGRAM
        </Button>
      </a>
      <FormGroup>
        <FormControlLabel control={<BpCheckbox onClick={() => setTermsAndConditionsAccepted(!termsAndConditionsAccepted)} />} label={
          <Typography variant='body2'>
            I have read and agree to the <button style={{ textDecoration: "underline" }} onClick={() => window.open(TermsAndConditionsPDF, '_blank')}>Terms and Conditions</button>
          </Typography>
        } />
      </FormGroup>
      <Box sx={{ mt: '1rem', display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button color='inherit' disabled={props.activeStep === 0} onClick={props.handleBack} sx={{ mr: 1 }}>
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />
        <Button disabled type='submit'>
          Next
        </Button>
      </Box>
    </React.Fragment>
  );
};

export default StepFourteenJoin;
